<template>
  <v-card
    class="mx-auto"
    max-width="252"
    elevation="2"
  >
    <v-list>
      <v-list-group
        v-for="item in menus"
        :key="item.nome"
        :prepend-icon="item.icon"
        no-action
      >
        <template v-slot:activator>
          <v-list-item-content class="text-left">
            <v-list-item-title v-text="item.nome"></v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="child in item.children"
          :key="child.nome"
          link
          :to="child.link"
        >
          <v-list-item-content>
            <v-list-item-title
              class="text-right"
              v-text="child.nome"
            ></v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon class="ml-1">
            <v-icon v-text="child.icon"></v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import { baseApiUrl } from '@/global'
import axios from 'axios'
export default {
  name: 'Menu',
  computed: mapState(['isMenuVisible', 'user']),
  data: function () {
    return {
      menus: [],
      admins: [
        ['Management', 'mdi-account-multiple-outline'],
        ['Settings', 'mdi-cog-outline']
      ]
    }
  },
  methods: {
    getTreeData () {
      const id = this.user.id
      const url = `${baseApiUrl}/menu-tree/${id}`
      axios.get(url).then(res => {
        this.menus = res.data
      })
    },
    onNodeSelect (node) {
      this.$router.push({
        name: 'teste',
        params: { id: node.id }
      })

      if (this.$mq === 'xs' || this.$mq === 'sm') {
        this.$store.commit('toggleMenu', false)
      }
    }
  },
  mounted () {
    this.getTreeData()
  }

}
</script>

<style scoped>
.menu {
  grid-area: menu;
  background: linear-gradient(to right, #d3dbe1, #f6f8fa);

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  min-height: 100%;
}

.menu a,
.menu a:hover {
  color: rgba(248, 251, 255, 0.946);
  text-decoration: none;
}

.menu .tree-node.selected > .tree-content,
.menu .tree-node .tree-content:hover {
  background-color: rgba(255, 255, 255, 0.713);
}

.tree-arrow.has-child {
  filter: brightness(2);
}

.menu .menu-filter {
  display: flex;
  justify-content: center;
  align-items: center;

  margin: 20px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgb(92, 111, 136);
}

.menu .menu-filter i {
  color: rgb(28, 27, 27);
  margin-right: 10px;
}

.menu input {
  color: rgb(28, 27, 27);
  font-size: 1.3rem;
  border: 0;
  outline: 0;
  width: 100%;
  background: transparent;
}

.tree-filter-empty {
  color: rgb(22, 21, 21);
  font-size: 1.3rem;
  margin-left: 20px;
}
.borda-vm {
  border: solid 1px red;
}
.borda-bl {
  border: solid 1px blue;
}
</style>
